
import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator'

@Component
export default class PhoneNumber extends Vue {
  @Prop({type: String, default: 'Phone Number'})
  public label!: string

  @Prop({type: String, default: ''})
  public value!: string

  @Prop({type: Array, default: null})
  public rules!: any[]

  public defaultRules = [
    (v: string) =>
        /^\+\d+ \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/.test(v)
        || 'Please enter your 10 digit Phone Number'
  ]

  @Ref() public readonly inputField!: HTMLInputElement

  public phoneNumber: string = ''

  private metaReg = /[\(\)\-\s]/g

  @Watch('value', {immediate: true})
  public valueWatch() {
    if (this.value !== this.stripMeta(this.phoneNumber)) {
      const withoutCountry = this.value.replace(/^\+1?/, '')
      const areaCode = withoutCountry.substr(0, 3)
      const exchangeCode = withoutCountry.substr(3, 3)
      const lineNumber = withoutCountry.substr(6, 4)

      let phoneNumber = '+1 ('
      if (areaCode) {
        phoneNumber += areaCode
      }
      if (exchangeCode) {
        phoneNumber += `) ${exchangeCode}`
      }
      if (lineNumber) {
        phoneNumber += `-${lineNumber}`
      }

      this.phoneNumber = phoneNumber
    }
  }

  @Watch('phoneNumber')
  public phoneNumberWatch() {
    if (!this.phoneNumber) {
      return
    }

    if (this.value !== this.stripMeta(this.phoneNumber)) {
      this.input()
    }
  }

  @Emit()
  public input() {
    return this.stripMeta(this.phoneNumber)
  }

  // Input element method pass through
  public focus() {
    // this.inputField.focus()
  }

  public blur() {
    // this.inputField.blur()
  }

  private stripMeta(val: string) {
    if (!val) {
      return ''
    }

    return val.replace(this.metaReg, '')
  }

}
